import ReactDOM from 'react-dom';
import React from 'react';
import Form from './form.jsx';


//this.mainElement = ReactDOM.hydrate(
//console.log('change this to hydrate');
//we render this in webpack
ReactDOM.hydrate(
    <Form />,
    window.document.getElementById('contact-form')
);
